import { useState } from "react";
import { useListingFilters } from "../../hooks/useListingFilters";
import { ListingCard } from "../ListingCard";
import { Button } from "../ui/button";
import { useAuth } from "../../contexts/AuthContext";

export const LisitngGrid = ({ listings }) => {
  const { currentUser } = useAuth();                      
  const currentUserId = currentUser?._id || null;  
  const { applyFilters } = useListingFilters();
  const filteredListings = applyFilters(listings);

  const INITIAL_VISIBLE = 16;
  const INCREMENT = 16;

  const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE);

  const handleShowMore = () => {
    setVisibleCount((prev) => prev + INCREMENT);
  };

  const handleShowLess = () => {
    setVisibleCount(INITIAL_VISIBLE);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const visibleListings = filteredListings.slice(0, visibleCount);
  console.log("listingssssss", listings);
  

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {visibleListings.map((listing) => (
          <ListingCard
            key={listing._id}
            id={listing._id}
            title={listing.title}
            description={listing.description}
            imageUrl={listing.image}
            location={listing.location}
            distanceBand={listing.distanceBand}
            date={new Date(listing.createdAt).toLocaleDateString()}
            category={listing.category}
            userName={`${listing.seller?.firstName || "Unknown"} ${listing.seller?.lastName || ""}`}
            userAvatar={listing.seller?.image}
            userRating={listing.seller?.rating}
            isOwner={listing.seller?._id === currentUserId}
            currentUserId={currentUserId}
            ownerId={listing.seller?._id}
            isFoundingMember={listing.seller?.isFoundingMember}
          />
        ))}
        {filteredListings.length === 0 && (
          <div className="col-span-full text-center py-8 text-gray-500">
            No listings found matching your filters.
          </div>
        )}
      </div>

      {/* Pagination Buttons */}
      {filteredListings.length > INITIAL_VISIBLE && (
        <div className="text-center mt-6 space-x-4">
          {visibleCount < filteredListings.length && (
            <Button
              onClick={handleShowMore}
            >
              Show More
            </Button>
          )}
          {visibleCount > INITIAL_VISIBLE && (
            <Button
              onClick={handleShowLess}
            >
              Show Less
            </Button>
          )}
        </div>
      )}
    </>
  );
};
